'use strict';

/**
* @ngdoc controller
* @name tcApp.controllers:OrderEntryCtrl
* @description
* Order Entry controller.
*
*/

angular.module('tcApp')
.value('orderentryData', null)
.controller('OrderEntryCtrl', function($scope, $window, $document, $location, $route, $log, $mdMedia, $mdUtil,
										orderentryData, GlobalService, LegacyScopeService) {
	if (orderentryData != null) {
		$scope.data = orderentryData.data;
	}
	if (angular.isUndefined($scope.data)) $scope.data = {};
	$scope.globalStrings = GlobalService.getGlobalStrings();
	$scope.viewModel = {
		orderentryHtmlName: 'tc_OrderEntry',
		workspaceHtmlName: 'OEWorkspace-workspace',
		workspaceTabs: {},
		portfolioTabs: {},
		chart: null,
		chartId: ''
	};
	$log.debug('orderentryCtrl ' + $scope.viewModel.orderentryHtmlName + ': ', $scope.data);
	
	var legacyFunctions = LegacyScopeService.getLegacyFunctions($scope);
	var websysCallFunction = legacyFunctions.websys_callFunction;
	
	var initialiseCtrl = function() {
		$document.ready(function() {
			
			if ((angular.isDefined($scope.data.cmpOEPortal)) && (angular.isDefined($scope.data.cmpOEPortal.data.items))) {
				if (angular.isDefined($scope.data.cmpOEPortal.data.items.OETabsWorkspace)) {
					$scope.viewModel.workspaceTabs = $scope.data.cmpOEPortal.data.items.OETabsWorkspace.value;
				}
				if (angular.isDefined($scope.data.cmpOEPortal.data.items.OETabsPortfolio)) {
					$scope.viewModel.portfolioTabs = $scope.data.cmpOEPortal.data.items.OETabsPortfolio.value;
				}
				if (($scope.data.cmpOEPortal.data.items.OEPortfolio)
				&& (angular.isDefined($scope.data.cmpOEPortal.data.items.OEPortfolio.value))) {
					var portfolioItems = $scope.data.cmpOEPortal.data.items.OEPortfolio.value;
					if (angular.isDefined(portfolioItems.chart)) {
						$scope.viewModel.chart = portfolioItems.chart;
						$scope.viewModel.chartId = portfolioItems.chartId;
					}
				}
			}

			angular.getTestability(angular.element($document[0].body)).whenStable(function() {
				$scope.scrollToItemSearch();
			});
		});
		
		if ($scope.data.bannerData) GlobalService.updateBannerData($scope.data.bannerData);
		$log.debug('orderentryCtrl initialised viewModel: ', $scope.viewModel);
	};
	
	$scope.getTabComponentName = function(tab) {
		var componentName = '';
		if ((angular.isDefined(tab.linkedcomponentname)) && (tab.linkedcomponentname != '')) {
			componentName = tab.linkedcomponentname;
		}
		return componentName;
	};
	
	$scope.selectComponentTab = function(tab) {
		var selectedComponentName = $scope.getTabComponentName(tab);
		if (selectedComponentName != '') {
			var params = tab.linkedcomponentparams;
			if (selectedComponentName==='OEOrder.Order.AlertMessage') {
				// The "selectedComponentName" is not matching the "$scope.componentHtmlName" which makes the
				// GlobalService.reloadComponent() failed to reload the component. 
				// Only fix the alert component here as only alert component has display issues at the moment.
				websysCallFunction('OEOrder.Order.AlertMessage','OEOrder_Order_AlertMessage_Reload');
			} else {
				GlobalService.reloadComponent(selectedComponentName, params);
			}
		}
	};
	
	$scope.selectPortfolioTab = function(tabItem, tabIndex) {
		$scope.viewModel.portfolioTabs.selectedIndex = tabIndex;
		if ((tabItem) && (tabItem.name == 'OECHART')) {
			if ($scope.viewModel.chartId === '') {
				$window.alert('no chart defined');
				return false;
			}
			if ((angular.isUndefined($scope.viewModel.chart.data.charts))
			|| ($scope.viewModel.chart.data.charts.length == 0)) {
				$scope.showChart();
			}
		} else if (tabItem) {
			$scope.selectComponentTab(tabItem);
		}
	};
	$scope.showChart = function() {
		$scope.$broadcast('Component:reloadChart', 
			'#/Chart//' + $scope.viewModel.chartId + '//?TRELOADJS=PortalReloadAfterItemUpdate()');
	};
	
	/// reload the OEOrder.EntryPortal.ListLookup
	/// need to ensure the reload happens at the top most table when in nested/tree mode
	$scope.reloadListLookup = function(url) {
		$scope.data.cmpOEPortal.data.items.OEWorkspace.value.cmpList.data.listData.pageCount = 1;
		
		GlobalService.reloadComponent('OEOrder_EntryPortal_ListLookup_0', {skipBanner: true, requestParameters: url});
	};
	
	$scope.cleanListLookupNestedState = function() {
		var oWorkspace = $scope.data.cmpOEPortal.data.items.OEWorkspace.value;
		
		// main list, OEOrder.EntryPortal.ListLookup
		var startCmpData = oWorkspace.cmpList.data;
		var startPath = 'cmpList.data';
		var nestedItemName = 'drillTree';
		
		/// recurse through the nested lists and reset the .expanded property
		var recurseTree = function(cmpData, path) {
			if ((cmpData.listData) && (angular.isDefined(cmpData.listData.nestedListItems))) {
				var nestedItem, nestedCmpData, nestedPath, currentPath;
				for (var i = 0; i < cmpData.listRows.length; i++) {
					nestedItem = $scope.$eval('listRows[' + i + '].' + nestedItemName, cmpData);
					if ((nestedItem) && (angular.isDefined(nestedItem.expanded))) {
						currentPath = path + '.listRows[' + i + '].' + nestedItemName;
						if ((nestedItem.expanded) && (nestedItem.componentData)) {
							nestedCmpData = nestedItem.componentData;
							nestedPath = currentPath + '.componentData';
							recurseTree(nestedCmpData, nestedPath);
						}
						
						$scope.$eval(currentPath + '.expanded = undefined', oWorkspace);
					}
				}
			}
		};
		
		recurseTree(startCmpData, startPath);
		
		// order set, OEOrder.Entry.OSItemList
		startCmpData = oWorkspace.cmpOrderSetSelector.data;
		startPath = 'cmpOrderSetSelector.data';
		nestedItemName = 'szNarrativeCmp';
		recurseTree(startCmpData, startPath);
	};
	
	$scope.scrollToItemSearch = function() {
		var identifier = '[id$="-item-ItemSearch"]';
		var oItemSearch = $scope.scrollToWorkspaceItem(identifier);
		if (oItemSearch) {
			oItemSearch.focus();
			return oItemSearch;
		}
	};
	
	$scope.scrollToWorkspaceItem = function(identifier) {
		var oItemToScrollTo = null;
		if (identifier != '') oItemToScrollTo = $window.document.querySelector(identifier);
		if (oItemToScrollTo) {
			var idWorkspace = $scope.viewModel.workspaceHtmlName;
			if (!$window.document.getElementById(idWorkspace)) idWorkspace = null;
			GlobalService.scrollToElement(oItemToScrollTo, 0, idWorkspace);
		}
		return oItemToScrollTo;
	};
	
	$scope.$on('Global:userLogon', function(event, sessionData) {
		$scope.globalStrings = sessionData.globalStrings;
	});
	$scope.$on('Global:callFunction', function(event, componentHtmlName, functionName, args, callbackFunction) {
		if (componentHtmlName !== 'OrderEntry') return;
		
		if (angular.isFunction($scope[functionName])) {
			var returnValue = $scope[functionName].apply(this, args);
			if (angular.isFunction(callbackFunction)) callbackFunction(returnValue);
		} else {
			$log.warn('Could not find function ', functionName, ' in ', componentHtmlName, ' controller');
		}
	});
	
	initialiseCtrl();
});
